module.exports = __webpack_public_path__ + "img/vote-3.6c02968f.png";